import React from 'react'
import { parseRich } from '../model'

// Callout, FieldError, Ask e Hint moram em components/wizardKit/basics: a campanha de
// recuperação usa os mesmos. Este arquivo repassa e guarda o que é só daqui.
export { Callout, FieldError, Ask, Hint } from '../../../../components/wizardKit/basics'

/** Texto com **negrito** (a frase inteira é uma chave de tradução). */
export const Rich: React.FC<{ text: string }> = ({ text }) => (
  <>
    {parseRich(text).map((part, i) => (part.bold ? <b key={i}>{part.text}</b> : <React.Fragment key={i}>{part.text}</React.Fragment>))}
  </>
)
